export enum BULLJSQUEUENAMES {
    SAMPLE_JOB = 'SAMPLE_JOB',
    ASSET_ACTIVITY_CONTROLLER_JOB = 'ASSET_ACTIVITY_CONTROLLER_JOB',
}
